import React, { useEffect, useRef, useState } from "react";
import "./SortDropdown.css";

const OPTIONS = [
  { value: "recent", label: "Plus récents" },
  { value: "oldest", label: "Plus anciens" },
];

export default function SortDropdown({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = OPTIONS.find((o) => o.value === value);

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="sort-control" ref={ref}>
      <button
        type="button"
        className={`sort-btn ${open ? "open" : ""}`}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="sort-btn-label">Trier par</span>
        {current && <span className="sort-btn-value">{current.label}</span>}
        <span className="sort-btn-chevron" aria-hidden="true" />
      </button>

      <ul className={`sort-menu ${open ? "open" : ""}`} role="listbox" aria-label="Trier par">
        {OPTIONS.map((o) => (
          <li
            key={o.value}
            role="option"
            aria-selected={o.value === value}
            className={o.value === value ? "selected" : ""}
            tabIndex={open ? 0 : -1}
            onClick={() => {
              onChange(o.value);
              setOpen(false);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onChange(o.value);
                setOpen(false);
              }
            }}
          >
            {o.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
